import {
  PAYCHECKS,
  SHOW_PAYCHECK,
  CREATE_PAYCHECK,
  SEARCH_PAYCHECKS,
} from './actionTypes';
import axios from '../../utils/axios';
import progressUpdate from '../progress';
import { hideSnackbar, showSnackbar } from '../snackbar';

const getPaychecks = page => (dispatch) => {
  dispatch({ type: `${PAYCHECKS}_REQUEST` });
  axios.get(`paychecks?page=${page}`, { data: {} })
    .then(({ data: { paychecks, total_paychecks, total_pages } }) =>
      dispatch({
        type: `${PAYCHECKS}_SUCCESS`,
        paychecks,
        total: total_paychecks,
        pages: total_pages,
      }))
    .catch(error => dispatch({ type: `${PAYCHECKS}_ERROR`, error }));
};

const showPaycheck = id => (dispatch) => {
  dispatch({ type: `${SHOW_PAYCHECK}_REQUEST` });
  axios.get(`paychecks/${id}`, { data: {} })
    .then(response => dispatch({ type: `${SHOW_PAYCHECK}_SUCCESS`, paycheck: response.data.paycheck }))
    .catch(error => dispatch({ type: `${SHOW_PAYCHECK}_ERROR`, error }));
};

const createPaycheck = paycheck => (dispatch) => {
  dispatch({ type: `${CREATE_PAYCHECK}_REQUEST` });
  dispatch(progressUpdate(0));
  dispatch(hideSnackbar());
  axios.post('paychecks', paycheck, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      dispatch(progressUpdate(percentCompleted));
    },
  })
    .then(() => {
      dispatch(showSnackbar('El recibo fue cargado correctamente.', 'success'));
      dispatch({ type: `${CREATE_PAYCHECK}_SUCCESS` });
    })
    .catch((error) => {
      dispatch(showSnackbar('Ha ocurrido un error al cargar el recibo', 'error'));
      dispatch({ type: `${CREATE_PAYCHECK}_ERROR`, error });
    });
};

const search = query => (dispatch) => {
  dispatch({ type: `${SEARCH_PAYCHECKS}_REQUEST` });
  axios.get('paychecks/search', {
    params: query,
    data: {} })
    .then(({ data: { paychecks, total_paychecks, total_pages } }) =>
      dispatch({
        type: `${SEARCH_PAYCHECKS}_SUCCESS`,
        paychecks,
        total: total_paychecks,
        pages: total_pages,
      }))
    .catch(error => dispatch({ type: `${SEARCH_PAYCHECKS}_ERROR`, error }));
};

export {
  search,
  getPaychecks,
  showPaycheck,
  createPaycheck,
};



// WEBPACK FOOTER //
// ./src/actions/paychecks/index.js